import { render } from "./IconCasePageBuildYear.vue?vue&type=template&id=504daca2&scoped=true"
const script = {}

import "./IconCasePageBuildYear.vue?vue&type=style&index=0&id=504daca2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-504daca2"]])

export default __exports__